var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 195,
    viewBox: "0 0 199 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_244_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.45 1H38.25C17.68 1 1 17.3 1 37.41V157.8C1 177.91 17.68 194.21 38.25 194.21H161.44C182.01 194.21 198.7 177.91 198.7 157.8V37.41C198.7 17.3 182.02 1 161.44 1H161.45Z",
    fill: "#4FA0D8",
    stroke: "url(#paint0_linear_244_2)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_244_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.26 86.01C160.77 69.63 157.46 54.99 162.23 37.14C162.41 36.46 162.23 35.79 161.75 35.27C161.26 34.75 160.59 34.53 159.87 34.66C148.26 36.63 134.13 42.8 126.61 51.55C125.6 52.45 124.23 52.78 122.92 52.45C118.52 51.36 114.33 50.64 110.06 50.22C106.72 49.76 103.31 49.5 99.84 49.5C96.37 49.5 92.96 49.76 89.62 50.22C85.33 50.65 81.15 51.36 76.75 52.45C75.44 52.78 74.07 52.45 73.06 51.55C65.54 42.81 51.36 36.63 39.76 34.66C39.04 34.54 38.37 34.76 37.88 35.27C37.39 35.79 37.21 36.45 37.4 37.14C42.17 54.99 38.89 69.64 33.42 86.01C29.55 97.57 23.17 106.54 23.46 123.69C23.46 124.11 23.72 124.45 24.1 124.61C24.5 124.77 24.92 124.69 25.23 124.4C29.16 120.66 31.53 119.78 33.52 120.82C36.7 122.48 32.55 131.01 39.83 137.41C40.14 137.68 40.58 137.75 40.96 137.58C41.35 137.4 41.58 137.04 41.57 136.63C41.42 132.48 43.94 130.16 45.53 129.68C47.24 129.15 49.51 129.63 52.1 132.27C57.68 137.93 63.4 143.68 70.24 148.37C75.09 151.7 80.14 154.51 85.32 156.84C90.19 159.2 95.01 160.42 99.83 160.45C104.65 160.42 109.47 159.2 114.34 156.84C119.51 154.52 124.56 151.7 129.42 148.37C136.26 143.68 141.97 137.94 147.56 132.27C150.15 129.63 152.42 129.17 154.13 129.68C155.72 130.17 157.95 133.36 157.8 137.51C157.78 137.93 158.02 138.28 158.41 138.46C158.8 138.63 159.23 138.57 159.54 138.29C166.82 131.89 162.96 122.49 166.13 120.82C168.12 119.77 170.48 120.66 174.43 124.4C174.73 124.69 175.16 124.77 175.56 124.61C175.96 124.45 176.2 124.11 176.21 123.69C176.51 106.55 170.13 97.57 166.25 86.01H166.26ZM82.18 121.36C77.56 121.29 70.71 120.3 65.77 114.98C63.58 112.62 59.86 107.32 60.38 97.26C60.4 96.82 60.99 96.58 61.39 96.86C62.72 97.79 65.3 99.56 67.87 101.29C70.89 103.32 97.96 121.54 82.18 121.36ZM135.08 114.98C130.14 120.3 123.29 121.28 118.67 121.36C102.89 121.54 129.96 103.33 132.98 101.29C135.55 99.56 138.12 97.78 139.46 96.86C139.87 96.58 140.45 96.81 140.47 97.26C140.99 107.33 137.26 112.62 135.08 114.98Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_244_2",
    x: 9.45044,
    y: 30.6235,
    width: 180.77,
    height: 153.827,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.137255 0 0 0 0 0.121569 0 0 0 0 0.12549 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_244_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_244_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_244_2",
    x1: -1.33975e-8,
    y1: 97.61,
    x2: 199.7,
    y2: 97.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BCEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B9DD6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_244_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199,
    height: 195,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobLogo);
export default __webpack_public_path__ + "static/media/mob-logo.2f161cc6e4056e8dc222b0d689d8ac80.svg";
export { ForwardRef as ReactComponent };